// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ChangePassword_inputWrapper__fLyJP"};